import { render } from "./UbchiSolve.vue?vue&type=template&id=681dd172"
import script from "./UbchiSolve.vue?vue&type=script&lang=js"
export * from "./UbchiSolve.vue?vue&type=script&lang=js"
script.render = render

export default script